const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'

async function request(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.detail || 'Request failed')
  }
  return res.json()
}

export const api = {
  // Business
  getBusiness: (userId) => request(`/businesses/${userId}`),
  createBusiness: (data) => request('/businesses', { method: 'POST', body: JSON.stringify(data) }),
  updateBusiness: (id, data) => request(`/businesses/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  // Jobs
  getJobs: (businessId) => request(`/jobs/${businessId}`),
  createJob: (data) => request('/jobs', { method: 'POST', body: JSON.stringify(data) }),
  updateJob: (id, data) => request(`/jobs/${id}/update`, { method: 'PUT', body: JSON.stringify(data) }),
  completeJob: (jobId) => request(`/jobs/${jobId}/complete`, { method: 'PUT' }),
  deleteJob: (jobId) => request(`/jobs/${jobId}`, { method: 'DELETE' }),

  // Stripe
  getSubscriptionStatus: (businessId) => request(`/stripe/subscription-status/${businessId}`),
  createCheckoutSession: (data) => request('/stripe/create-checkout', { method: 'POST', body: JSON.stringify(data) }),
  createBillingPortal: (businessId) => request(`/stripe/create-portal?business_id=${businessId}`, { method: 'POST' }),
}
